import React from 'react';
import cn from 'classnames';

import Image from './Image';

import * as styles from './BookCover.module.css';

const BookCover = ({ coverImage, bookName, className, noShadow }) => {
  return (
    <div
      className={cn(styles.root, className, {
        [styles.withShadow]: !noShadow
      })}
    >
      <Image image={coverImage} alt={bookName} />
    </div>
  );
};

export default BookCover;
